
class formulaColumnsParser {
    
    tokenize(formula) {
        const regex = /"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|\[([^\]]+)\]|\{\{([^}]+)\}\}|[a-zA-Z_][\w]*|\d+\.\d+|\d+|==|!=|<=|>=|<>|[+\-*/=<>(),]/g;
        const tokens = [];
        let match;
        while ((match = regex.exec(formula)) !== null) {
            tokens.push(match[0]);
        }
        return tokens;
    }

    buildAST(tokens) {
        let i = 0;

        const parseExpression = () => {
            if (i >= tokens.length) return null;

            let token = tokens[i];

            // Handle string literal
            if (/^["'].*["']$/.test(token)) {
                i++;
                return { type: 'literal', value: token.slice(1, -1) };
            }

            // Handle functions: IF, SWITCH, CHOOSE
            const upperToken = token.toUpperCase();

            if (['IF', 'SWITCH', 'CHOOSE'].includes(upperToken)) {
                i++; // skip function name

                if (tokens[i] !== '(') throw new Error(`Expected '(' after ${upperToken}`);
                i++; // skip '('

                const args = parseArguments();

                return { type: upperToken, args };
            }

            // Otherwise, simple token
            i++;
            return { type: 'token', value: token };
        };

        const parseArguments = () => {
            const args = [];
            let current = [];
            let depth = 0;

            while (i < tokens.length) {
                const token = tokens[i];

                if (token === '(') {
                    depth++;
                    current.push(token);
                    i++;
                } else if (token === ')') {
                    if (depth === 0) {
                        if (current.length) args.push(this.buildAST(current));
                        i++;
                        break;
                    } else {
                        depth--;
                        current.push(token);
                        i++;
                    }
                } else if (token === ',' && depth === 0) {
                    args.push(this.buildAST(current));
                    current = [];
                    i++;
                } else {
                    current.push(token);
                    i++;
                }
            }
            return args;
        };

        return parseExpression();
    }

    collectLiterals(ast, results = new Set()) {
        if (!ast) return;

        if (ast.type === 'literal') {
            results.add(ast.value);
            return;
        }

        if (ast.type === 'IF') {
            // IF(cond, trueVal, falseVal)
            if (ast.args.length >= 2) {
                this.collectLiterals(ast.args[1], results); // trueVal
            }
            if (ast.args.length >= 3) {
                this.collectLiterals(ast.args[2], results); // falseVal
            }
        }

        else if (ast.type === 'SWITCH') {
            // SWITCH(expr, match1, result1, ..., default)
            for (let i = 1; i < ast.args.length - 1; i += 2) {
                this.collectLiterals(ast.args[i + 1], results); // results in pairs
            }
            // If odd number of args, last is default
            if (ast.args.length % 2 === 0 && ast.args.length > 1) {
                this.collectLiterals(ast.args[ast.args.length - 1], results);
            }
        }

        else if (ast.type === 'CHOOSE') {
            // CHOOSE(index, option1, option2, ...)
            for (let i = 1; i < ast.args.length; i++) {
                this.collectLiterals(ast.args[i], results);
            }
        }

        else if (ast.args) {
            ast.args.forEach(arg => this.collectLiterals(arg, results));
        }
    }

    extractOutputLiteralsFromFormula(formula) {
        const tokens = this.tokenize(formula);
        const ast = this.buildAST(tokens);
        const literals = new Set();
        this.collectLiterals(ast, literals);
        return Array.from(literals);
    }


}

export default new formulaColumnsParser();